// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { SimulationAssetKind } from "./simulation-asset-kind";
import {
  SimulationCaptureFlow,
  SimulationCaptureFlowT,
  verifySimulationCaptureFlow,
} from "./simulation-capture-flow";
import {
  SimulationOpcUaDevice,
  SimulationOpcUaDeviceT,
  verifySimulationOpcUaDevice,
} from "./simulation-opc-ua-device";
import { Uuid, UuidT, verifyUuid } from "../front-end/uuid";

/**
 * An uploaded capture or OPC UA domain.
 */
export class SimulationAsset implements flatbuffers.IUnpackableObject<SimulationAssetT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): SimulationAsset {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsSimulationAsset(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationAsset,
  ): SimulationAsset {
    return (obj || new SimulationAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsSimulationAsset(
    bb: flatbuffers.ByteBuffer,
    obj?: SimulationAsset,
  ): SimulationAsset {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new SimulationAsset()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  id(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  organizationId(obj?: Uuid): Uuid | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset
      ? (obj || new Uuid()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  kind(): SimulationAssetKind {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SimulationAssetKind.CAPTURE;
  }

  /**
   * Display name.
   */
  name(): string | null;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  name(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * The uploaded file's name.
   */
  fileName(): string | null;
  fileName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  fileName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  sizeBytes(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : 0n;
  }

  /**
   * Lowercase hex SHA-256 of `content`.
   */
  sha256(): string | null;
  sha256(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  sha256(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * RFC 3339.
   */
  createdAt(): string | null;
  createdAt(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdAt(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  createdBy(): string | null;
  createdBy(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  createdBy(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  /**
   * Conversations found in a CAPTURE asset.
   */
  flows(index: number, obj?: SimulationCaptureFlow): SimulationCaptureFlow | null {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset
      ? (obj || new SimulationCaptureFlow()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  flowsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Devices found in an OPCUA_DOMAIN asset.
   */
  opcuaDevices(index: number, obj?: SimulationOpcUaDevice): SimulationOpcUaDevice | null {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset
      ? (obj || new SimulationOpcUaDevice()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  opcuaDevicesLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * Problems found while inspecting the file.
   */
  warnings(index: number): string;
  warnings(index: number, optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  warnings(index: number, optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset
      ? this.bb!.__string(this.bb!.__vector(this.bb_pos + offset) + index * 4, optionalEncoding)
      : null;
  }

  warningsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  /**
   * The file itself. Carried only inside `SimulationStartRunRequest` and
   * inspect requests; list and get responses leave it empty.
   */
  content(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  contentLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  contentArray(): Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset
      ? new Uint8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  static startSimulationAsset(builder: flatbuffers.Builder) {
    builder.startObject(13);
  }

  static addId(builder: flatbuffers.Builder, idOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, idOffset, 0);
  }

  static addOrganizationId(builder: flatbuffers.Builder, organizationIdOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, organizationIdOffset, 0);
  }

  static addKind(builder: flatbuffers.Builder, kind: SimulationAssetKind) {
    builder.addFieldInt8(2, kind, SimulationAssetKind.CAPTURE);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, nameOffset, 0);
  }

  static addFileName(builder: flatbuffers.Builder, fileNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, fileNameOffset, 0);
  }

  static addSizeBytes(builder: flatbuffers.Builder, sizeBytes: bigint) {
    builder.addFieldInt64(5, sizeBytes, 0n);
  }

  static addSha256(builder: flatbuffers.Builder, sha256Offset: flatbuffers.Offset) {
    builder.addFieldOffset(6, sha256Offset, 0);
  }

  static addCreatedAt(builder: flatbuffers.Builder, createdAtOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, createdAtOffset, 0);
  }

  static addCreatedBy(builder: flatbuffers.Builder, createdByOffset: flatbuffers.Offset) {
    builder.addFieldOffset(8, createdByOffset, 0);
  }

  static addFlows(builder: flatbuffers.Builder, flowsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(9, flowsOffset, 0);
  }

  static createFlowsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startFlowsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addOpcuaDevices(builder: flatbuffers.Builder, opcuaDevicesOffset: flatbuffers.Offset) {
    builder.addFieldOffset(10, opcuaDevicesOffset, 0);
  }

  static createOpcuaDevicesVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startOpcuaDevicesVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addWarnings(builder: flatbuffers.Builder, warningsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(11, warningsOffset, 0);
  }

  static createWarningsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startWarningsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addContent(builder: flatbuffers.Builder, contentOffset: flatbuffers.Offset) {
    builder.addFieldOffset(12, contentOffset, 0);
  }

  static createContentVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startContentVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static endSimulationAsset(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  unpack(): SimulationAssetT {
    return new SimulationAssetT(
      this.id() !== null ? this.id()!.unpack() : null,
      this.organizationId() !== null ? this.organizationId()!.unpack() : null,
      this.kind(),
      this.name(),
      this.fileName(),
      this.sizeBytes(),
      this.sha256(),
      this.createdAt(),
      this.createdBy(),
      this.bb!.createObjList<SimulationCaptureFlow, SimulationCaptureFlowT>(
        this.flows.bind(this),
        this.flowsLength(),
      ),
      this.bb!.createObjList<SimulationOpcUaDevice, SimulationOpcUaDeviceT>(
        this.opcuaDevices.bind(this),
        this.opcuaDevicesLength(),
      ),
      this.bb!.createScalarList<string>(this.warnings.bind(this), this.warningsLength()),
      this.bb!.createScalarList<number>(this.content.bind(this), this.contentLength()),
    );
  }

  unpackTo(_o: SimulationAssetT): void {
    _o.id = this.id() !== null ? this.id()!.unpack() : null;
    _o.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    _o.kind = this.kind();
    _o.name = this.name();
    _o.fileName = this.fileName();
    _o.sizeBytes = this.sizeBytes();
    _o.sha256 = this.sha256();
    _o.createdAt = this.createdAt();
    _o.createdBy = this.createdBy();
    _o.flows = this.bb!.createObjList<SimulationCaptureFlow, SimulationCaptureFlowT>(
      this.flows.bind(this),
      this.flowsLength(),
    );
    _o.opcuaDevices = this.bb!.createObjList<SimulationOpcUaDevice, SimulationOpcUaDeviceT>(
      this.opcuaDevices.bind(this),
      this.opcuaDevicesLength(),
    );
    _o.warnings = this.bb!.createScalarList<string>(
      this.warnings.bind(this),
      this.warningsLength(),
    );
    _o.content = this.bb!.createScalarList<number>(this.content.bind(this), this.contentLength());
  }

  unpackFields(...fields: string[]): SimulationAssetT {
    const t = new SimulationAssetT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("id")) {
      t.id = this.id() !== null ? this.id()!.unpack() : null;
    }
    if (fieldSet.has("organization_id")) {
      t.organizationId = this.organizationId() !== null ? this.organizationId()!.unpack() : null;
    }
    if (fieldSet.has("kind")) {
      t.kind = this.kind();
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("file_name")) {
      t.fileName = this.fileName();
    }
    if (fieldSet.has("size_bytes")) {
      t.sizeBytes = this.sizeBytes();
    }
    if (fieldSet.has("sha256")) {
      t.sha256 = this.sha256();
    }
    if (fieldSet.has("created_at")) {
      t.createdAt = this.createdAt();
    }
    if (fieldSet.has("created_by")) {
      t.createdBy = this.createdBy();
    }
    if (fieldSet.has("flows")) {
      t.flows = this.bb!.createObjList<SimulationCaptureFlow, SimulationCaptureFlowT>(
        this.flows.bind(this),
        this.flowsLength(),
      );
    }
    if (fieldSet.has("opcua_devices")) {
      t.opcuaDevices = this.bb!.createObjList<SimulationOpcUaDevice, SimulationOpcUaDeviceT>(
        this.opcuaDevices.bind(this),
        this.opcuaDevicesLength(),
      );
    }
    if (fieldSet.has("warnings")) {
      t.warnings = this.bb!.createScalarList<string>(
        this.warnings.bind(this),
        this.warningsLength(),
      );
    }
    if (fieldSet.has("content")) {
      t.content = this.bb!.createScalarList<number>(this.content.bind(this), this.contentLength());
    }
    return t;
  }
}

export class SimulationAssetT implements flatbuffers.IGeneratedObject {
  constructor(
    public id: UuidT | null = null,
    public organizationId: UuidT | null = null,
    public kind: SimulationAssetKind = SimulationAssetKind.CAPTURE,
    public name: string | Uint8Array | null = null,
    public fileName: string | Uint8Array | null = null,
    public sizeBytes: bigint = 0n,
    public sha256: string | Uint8Array | null = null,
    public createdAt: string | Uint8Array | null = null,
    public createdBy: string | Uint8Array | null = null,
    public flows: SimulationCaptureFlowT[] = [],
    public opcuaDevices: SimulationOpcUaDeviceT[] = [],
    public warnings: string[] = [],
    public content: number[] = [],
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const id = this.id !== null ? this.id!.pack(builder) : 0;
    const organizationId = this.organizationId !== null ? this.organizationId!.pack(builder) : 0;
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const fileName = this.fileName !== null ? builder.createString(this.fileName!) : 0;
    const sha256 = this.sha256 !== null ? builder.createString(this.sha256!) : 0;
    const createdAt = this.createdAt !== null ? builder.createString(this.createdAt!) : 0;
    const createdBy = this.createdBy !== null ? builder.createString(this.createdBy!) : 0;
    const flows = SimulationAsset.createFlowsVector(
      builder,
      builder.createObjectOffsetList(this.flows),
    );
    const opcuaDevices = SimulationAsset.createOpcuaDevicesVector(
      builder,
      builder.createObjectOffsetList(this.opcuaDevices),
    );
    const warnings = SimulationAsset.createWarningsVector(
      builder,
      builder.createObjectOffsetList(this.warnings),
    );
    const content = SimulationAsset.createContentVector(builder, this.content);

    SimulationAsset.startSimulationAsset(builder);
    SimulationAsset.addId(builder, id);
    SimulationAsset.addOrganizationId(builder, organizationId);
    SimulationAsset.addKind(builder, this.kind);
    SimulationAsset.addName(builder, name);
    SimulationAsset.addFileName(builder, fileName);
    SimulationAsset.addSizeBytes(builder, this.sizeBytes);
    SimulationAsset.addSha256(builder, sha256);
    SimulationAsset.addCreatedAt(builder, createdAt);
    SimulationAsset.addCreatedBy(builder, createdBy);
    SimulationAsset.addFlows(builder, flows);
    SimulationAsset.addOpcuaDevices(builder, opcuaDevices);
    SimulationAsset.addWarnings(builder, warnings);
    SimulationAsset.addContent(builder, content);

    return SimulationAsset.endSimulationAsset(builder);
  }

  clone(): SimulationAssetT {
    const obj = new SimulationAssetT();
    obj.id = this.id !== null ? this.id!.clone() : null;
    obj.organizationId = this.organizationId !== null ? this.organizationId!.clone() : null;
    obj.kind = this.kind;
    obj.name = this.name;
    obj.fileName = this.fileName;
    obj.sizeBytes = this.sizeBytes;
    obj.sha256 = this.sha256;
    obj.createdAt = this.createdAt;
    obj.createdBy = this.createdBy;
    obj.flows = this.flows.map((e) => e.clone());
    obj.opcuaDevices = this.opcuaDevices.map((e) => e.clone());
    obj.warnings = [...this.warnings];
    obj.content = [...this.content];
    return obj;
  }

  equals(other: SimulationAssetT): boolean {
    if (this.id !== null && other.id !== null) {
      if (!this.id!.equals(other.id!)) return false;
    } else if (this.id !== other.id) return false;
    if (this.organizationId !== null && other.organizationId !== null) {
      if (!this.organizationId!.equals(other.organizationId!)) return false;
    } else if (this.organizationId !== other.organizationId) return false;
    if (this.kind !== other.kind) return false;
    if (this.name !== other.name) return false;
    if (this.fileName !== other.fileName) return false;
    if (this.sizeBytes !== other.sizeBytes) return false;
    if (this.sha256 !== other.sha256) return false;
    if (this.createdAt !== other.createdAt) return false;
    if (this.createdBy !== other.createdBy) return false;
    if (this.flows.length !== other.flows.length) return false;
    for (let i = 0; i < this.flows.length; i++) {
      const a = this.flows[i];
      const b = other.flows[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.opcuaDevices.length !== other.opcuaDevices.length) return false;
    for (let i = 0; i < this.opcuaDevices.length; i++) {
      const a = this.opcuaDevices[i];
      const b = other.opcuaDevices[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    if (this.warnings.length !== other.warnings.length) return false;
    for (let i = 0; i < this.warnings.length; i++) {
      if (this.warnings[i] !== other.warnings[i]) return false;
    }
    if (this.content.length !== other.content.length) return false;
    for (let i = 0; i < this.content.length; i++) {
      if (this.content[i] !== other.content[i]) return false;
    }
    return true;
  }
}

export function verifySimulationAsset(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 6);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUuid(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkScalarField(tablePos, 8, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 14, 8);
    {
      const pos = verifier.checkOffsetField(tablePos, 16);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 20);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 22);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationCaptureFlow);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 24);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifySimulationOpcUaDevice);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 26);
      if (pos !== 0) {
        const len = verifier.checkVector(pos, 4);
        if (len > 0) {
          const vecStart = pos + verifier.readInt32(pos);
          const dataStart = vecStart + 4;
          for (let i = 0; i < len; i++) {
            const strPos = dataStart + i * 4;
            verifier.checkString(strPos);
          }
        }
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 28);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
